import { useState } from 'react';
import { ModalContext } from './ModalContext';
import { ModalContainer } from '../container/ModalContainer';
import { ModalState } from '../ModalState';

export const ModalProvider = ({ children }: { children: React.ReactNode }) => {
  const [modal, setModal] = useState<ModalState | null>(null);

  const openModal = (modalState: ModalState) => {
    setModal(modalState);
  };

  const closeModal = () => {
    setModal(null);
  };

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      <ModalContainer modal={modal} onClose={closeModal} />
    </ModalContext.Provider>
  );
};
